
class NavOpenCart {
  constructor(element) {
    this.element = element;
    this.init();
  }

  getElement() {
    return this.element;
  }

  getCartIcon() {
    let element = this.getElement();
    return element.querySelector('.js-openCart');
  }

  openCart() {
    window.addEventListener('load', (event) => {
      let cartIcon = this.getCartIcon();
      cartIcon.addEventListener('click', () => {
        window.vueApp.$store.dispatch('cart/openSidecart')
      })
    });
	}

  setEventHandlers() {
    this.openCart();
  }

  init() {
    this.setEventHandlers();
  }
}


const NavOpenCartInit = {
  init() {
    const $el = document.querySelector("body");
    if ($el) {
        new NavOpenCart($el);
    }
  },
};


export default NavOpenCartInit;